import wordings from 'features/Programs/Shared/wordings.json'
import { MyCommuterArchived } from 'redux/employee/employeeTypes'

export const COMMUTER_SEARCH_KEYS = ['name', 'additionalInfo', 'tagNames'] as const

export const getCommuterTagFilterOptions = (
  commuters: Array<{ tagNames?: string[] }>
) => {
  const tags: string[] = []
  commuters.forEach((commuter) => {
    if (commuter.tagNames) {
      tags.push(...commuter.tagNames)
    }
  })

  const uniqueTags = [...new Set(tags)]

  if (!uniqueTags.length) {
    return null
  }

  return {
    header: 'Tags',
    checkboxes: uniqueTags.map((tag) => ({
      label: tag,
      checked: false,
      key: 'tagNames',
      value: tag,
    })),
  }
}

export const getVisibleTagNamesSummary = (tagNames?: string[]) => {
  if (!tagNames || tagNames.length === 0) {
    return { kind: 'empty' as const }
  }

  if (tagNames.length <= 2) {
    return { kind: 'list' as const, tags: tagNames }
  }

  return {
    kind: 'truncated' as const,
    tags: tagNames.slice(0, 2),
    overflowCount: tagNames.length - 2,
  }
}

export const partitionArchivedEmployees = (
  archivedEmployees: MyCommuterArchived[]
) => {
  const blockedEmployees = archivedEmployees.filter((employee) => employee.block)
  const nonBlockedArchivedEmployees = archivedEmployees.filter(
    (employee) => !employee.block
  )

  return { blockedEmployees, nonBlockedArchivedEmployees }
}

// the return should be
// [
//   {
//     id: 'Flex',
//     text: 'Flex',
//     type: 'program',
//   }
// ]
export const getAllProgramForColumn = (
  allFlexPrograms: object,
  allGrhPrograms: object,
  allQtfPrograms: object,
  allMicromobilityPrograms: object,
  segmentId: string
) => {
  const programsArray = []
  if (allFlexPrograms[segmentId]) {
    programsArray.push(getProgramNamesFromType('flex'))
  }
  if (allGrhPrograms[segmentId]) {
    programsArray.push(getProgramNamesFromType('grh'))
  }
  if (allQtfPrograms[segmentId]) {
    programsArray.push(getProgramNamesFromType('qtf'))
  }
  if (allMicromobilityPrograms[segmentId]) {
    programsArray.push(getProgramNamesFromType('micromobility'))
  }
  return programsArray
}

export const getProgramNamesForTagDeletion = (
  tagId: string,
  allFlexPrograms: object,
  allGrhPrograms: object,
  allQtfPrograms: object,
  allMicromobilityPrograms: object
) =>
  getAllProgramForColumn(
    allFlexPrograms,
    allGrhPrograms,
    allQtfPrograms,
    allMicromobilityPrograms,
    tagId
  )

export const tagHasProgramsThatWillBeCancelled = (
  tagId: string,
  allFlexPrograms: object,
  allGrhPrograms: object,
  allQtfPrograms: object,
  allMicromobilityPrograms: object
) =>
  getProgramNamesForTagDeletion(
    tagId,
    allFlexPrograms,
    allGrhPrograms,
    allQtfPrograms,
    allMicromobilityPrograms
  ).length > 0

export const getProgramNamesFromType = (type: string) => {
  if (type === 'flex') {
    return wordings.flex.title
  }
  if (type === 'grh') {
    return wordings.grh.title
  }
  if (type === 'qtf') {
    return wordings.qtf.title
  }
  if (type === 'micromobility') {
    return wordings.micromobility.title
  }
  return type.toUpperCase()
}
